export default "__VITE_PUBLIC_ASSET__9f574f58__"